import React from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import RemoteAutoSuggest from "./RemoteAutoSuggest";
import { Formik, Field, Form } from "formik";
import {
  DatePicker,
  DateRangePicker,
  RangeSlider,
  InputNumber,
  InputGroup,
} from "rsuite";
import moment from "moment";
import { Redirect, withRouter } from "react-router-dom";
import {
  DropdownButton,
  Dropdown,
  Modal,
  Button,
  Alert,
} from "react-bootstrap";
import { apiLoadFilter } from "../../services/apis/office/apiLoadFilter";
import { apiSaveFilter } from "../../services/apis/office/apiSaveFilter";
import { apiSaveRecentSearches } from "../../services/apis/office/apiSaveRecentSearches";
import {
  filterDataFromUrl,
  Url,
  keyMapping,
} from "../../services/utilities/util";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import LocalAutoSuggest from "./LocalAutoSuggest";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { apiMiddleware } from "../../services/apis/apiMiddleware";
// import {  } from "../../services/utilities/util";
import { connect } from "react-redux";

class SearchBox extends React.Component {
  state = {
    errorMsg: "",
    isOpen: false,
    city: [],
    region: [],
    macromarket: [],
    micromarket: [],
    pincode: [],
    complex: [],
    building: [],
    building_grade: [],
    // propertytype: [],
    building_category: [],
    spacetype: [],
    property_condition: [],
    tenant: [],
    sector: [],
    developer: [],
    landlord: [],
    ownership_type: [],
    owner: [],
    renewed_lease: [],
    document_type: [],
    active: [],
    Lease_Id: [],
    Sale_Id: [],
    seller: [],
    purchaser: [],
    end_status: [],
    brands_parent: [],

    securityDeposit: [0, 0],
    startingRent: [0, 0],
    startingRentCarpet: [0, 0],
    currentRent: [0, 0],
    currentRentCarpet: [0, 0],
    leaseTerm: [0, 0],
    rentFreePeriod: [0, 0],
    lockinPeriod: [0, 0],
    transactionSize: [0, 0],
    perSqFt: [0, 0],
    totalConsideration: [0, 0],
    areaPurchased: [0, 0],
    complexChargeableArea: [0, 0],
    buildingChargeableArea: [0, 0],

    start_leaseExpiryDate: null,
    end_leaseExpiryDate: null,
    months_leaseExpiryDate: "",

    start_lockinPeriodEndDate: null,
    end_lockinPeriodEndDate: null,
    months_lockinPeriodEndDate: "",

    start_executionDate: null,
    end_executionDate: null,
    months_executionDate: "",

    start_commencementDate: null,
    end_commencementDate: null,
    months_commencementDate: "",

    start_absorptionDate: null,
    end_absorptionDate: null,
    months_absorptionDate: "",

    start_occupancy_date_orig: null,
    end_occupancy_date_orig: null,
    months_occupancy_date_orig: "",

    start_exitDate: null,
    end_exitDate: null,
    months_exitDate: "",

    floor_number: [],

    redirect: false,
    uri: "",
    showAlert: false,
    showFilter: false,
    filters: [],

    filterSaveName: "",
    saveClicked: false,
    original_range_min_max: [],
  };

  componentDidMount() {
    this.setState({
      filters: this.props.filtersGroup,
      showFilter: this.props.showFilter,
    });
    //get filters from api
    var body = new FormData();
    body.append("screener", "edge_office");

    if (typeof Url.get.filter !== "undefined") {
      let original_range_min_max_arr = [];
      Object.keys(this.props.filtersGroup).map((main_category, i) =>
        Object.values(this.props.filtersGroup)[i].map((fields) => {
          if (fields.type === "range") {
            let rangeKey = fields["filter-name"];
            this.setState({ [rangeKey]: [fields.min, fields.max] });
            original_range_min_max_arr[fields["filter-name"]] = [
              fields.min,
              fields.max,
            ];
            this.setState({
              original_range_min_max: original_range_min_max_arr,
            });
          }
        })
      );

      var filterValues = JSON.parse(Url.get.filter);
      this.setState({
        city: typeof filterValues.city !== "undefined" ? filterValues.city : [],
        region:
          typeof filterValues.region !== "undefined" ? filterValues.region : [],
        macromarket:
          typeof filterValues.macromarket !== "undefined"
            ? filterValues.macromarket
            : [],
        micromarket:
          typeof filterValues.micromarket !== "undefined"
            ? filterValues.micromarket
            : [],
        pincode:
          typeof filterValues.pincode !== "undefined"
            ? filterValues.pincode
            : [],
        complex:
          typeof filterValues.complex !== "undefined"
            ? filterValues.complex
            : [],
        building:
          typeof filterValues.building !== "undefined"
            ? filterValues.building
            : [],
        building_grade:
          typeof filterValues.building_grade !== "undefined"
            ? filterValues.building_grade
            : [],
        // propertytype: (typeof filterValues.propertytype !== 'undefined') ? filterValues.propertytype : [],
        building_category:
          typeof filterValues.building_category !== "undefined"
            ? filterValues.building_category
            : [],
        spacetype:
          typeof filterValues.spacetype !== "undefined"
            ? filterValues.spacetype
            : [],
        property_condition:
          typeof filterValues.property_condition !== "undefined"
            ? filterValues.property_condition
            : [],
        tenant:
          typeof filterValues.tenant !== "undefined" ? filterValues.tenant : [],
        sector:
          typeof filterValues.sector !== "undefined" ? filterValues.sector : [],
        developer:
          typeof filterValues.developer !== "undefined"
            ? filterValues.developer
            : [],
        landlord:
          typeof filterValues.landlord !== "undefined"
            ? filterValues.landlord
            : [],
        ownership_type:
          typeof filterValues.ownership_type !== "undefined"
            ? filterValues.ownership_type
            : [],
        owner:
          typeof filterValues.owner !== "undefined" ? filterValues.owner : [],
        renewed_lease:
          typeof filterValues.renewed_lease !== "undefined"
            ? filterValues.renewed_lease
            : [],
        document_type:
          typeof filterValues.document_type !== "undefined"
            ? filterValues.document_type
            : [],
        active:
          typeof filterValues.active !== "undefined" ? filterValues.active : [],
        end_status:
          typeof filterValues.end_status !== "undefined"
            ? filterValues.end_status
            : [],
        Lease_Id:
          typeof filterValues.Lease_Id !== "undefined"
            ? filterValues.Lease_Id
            : [],
        Sale_Id:
          typeof filterValues.Sale_Id !== "undefined"
            ? filterValues.Sale_Id
            : [],
        seller:
          typeof filterValues.seller !== "undefined" ? filterValues.seller : [],
        purchaser:
          typeof filterValues.purchaser !== "undefined"
            ? filterValues.purchaser
            : [],
        brands_parent:
          typeof filterValues.brands_parent !== "undefined"
            ? filterValues.brands_parent
            : [],

        securityDeposit:
          typeof filterValues.securityDeposit !== "undefined"
            ? filterValues.securityDeposit
            : original_range_min_max_arr.securityDeposit,
        startingRent:
          typeof filterValues.startingRent !== "undefined"
            ? filterValues.startingRent
            : original_range_min_max_arr.startingRent,
        startingRentCarpet:
          typeof filterValues.startingRentCarpet !== "undefined"
            ? filterValues.startingRentCarpet
            : original_range_min_max_arr.startingRentCarpet,
        currentRent:
          typeof filterValues.currentRent !== "undefined"
            ? filterValues.currentRent
            : original_range_min_max_arr.currentRent,
        currentRentCarpet:
          typeof filterValues.currentRentCarpet !== "undefined"
            ? filterValues.currentRentCarpet
            : original_range_min_max_arr.currentRentCarpet,
        leaseTerm:
          typeof filterValues.leaseTerm !== "undefined"
            ? filterValues.leaseTerm
            : original_range_min_max_arr.leaseTerm,
        rentFreePeriod:
          typeof filterValues.rentFreePeriod !== "undefined"
            ? filterValues.rentFreePeriod
            : original_range_min_max_arr.rentFreePeriod,
        lockinPeriod:
          typeof filterValues.lockinPeriod !== "undefined"
            ? filterValues.lockinPeriod
            : original_range_min_max_arr.lockinPeriod,
        transactionSize:
          typeof filterValues.transactionSize !== "undefined"
            ? filterValues.transactionSize
            : original_range_min_max_arr.transactionSize,
        perSqFt:
          typeof filterValues.perSqFt !== "undefined"
            ? filterValues.perSqFt
            : original_range_min_max_arr.perSqFt,
        totalConsideration:
          typeof filterValues.totalConsideration !== "undefined"
            ? filterValues.totalConsideration
            : original_range_min_max_arr.totalConsideration,
        areaPurchased:
          typeof filterValues.areaPurchased !== "undefined"
            ? filterValues.areaPurchased
            : original_range_min_max_arr.areaPurchased,

        start_leaseExpiryDate:
          typeof filterValues.start_leaseExpiryDate !== "undefined"
            ? moment(filterValues.start_leaseExpiryDate).toDate()
            : null,
        end_leaseExpiryDate:
          typeof filterValues.end_leaseExpiryDate !== "undefined"
            ? moment(filterValues.end_leaseExpiryDate).toDate()
            : null,
        months_leaseExpiryDate:
          typeof filterValues.months_leaseExpiryDate !== "undefined"
            ? filterValues.months_leaseExpiryDate
            : "",

        start_lockinPeriodEndDate:
          typeof filterValues.start_lockinPeriodEndDate !== "undefined"
            ? moment(filterValues.start_lockinPeriodEndDate).toDate()
            : null,
        end_lockinPeriodEndDate:
          typeof filterValues.end_lockinPeriodEndDate !== "undefined"
            ? moment(filterValues.end_lockinPeriodEndDate).toDate()
            : null,
        months_lockinPeriodEndDate:
          typeof filterValues.months_lockinPeriodEndDate !== "undefined"
            ? filterValues.months_lockinPeriodEndDate
            : "",

        start_executionDate:
          typeof filterValues.start_executionDate !== "undefined"
            ? moment(filterValues.start_executionDate).toDate()
            : null,
        end_executionDate:
          typeof filterValues.end_executionDate !== "undefined"
            ? moment(filterValues.end_executionDate).toDate()
            : null,
        months_executionDate:
          typeof filterValues.months_executionDate !== "undefined"
            ? filterValues.months_executionDate
            : "",

        start_commencementDate:
          typeof filterValues.start_commencementDate !== "undefined"
            ? moment(filterValues.start_commencementDate).toDate()
            : null,
        end_commencementDate:
          typeof filterValues.end_commencementDate !== "undefined"
            ? moment(filterValues.end_commencementDate).toDate()
            : null,
        months_commencementDate:
          typeof filterValues.months_commencementDate !== "undefined"
            ? filterValues.months_commencementDate
            : "",

        start_absorptionDate:
          typeof filterValues.start_absorptionDate !== "undefined"
            ? moment(filterValues.start_absorptionDate).toDate()
            : null,
        end_absorptionDate:
          typeof filterValues.end_absorptionDate !== "undefined"
            ? moment(filterValues.end_absorptionDate).toDate()
            : null,
        months_absorptionDate:
          typeof filterValues.months_absorptionDate !== "undefined"
            ? filterValues.months_absorptionDate
            : "",

        start_occupancy_date_orig:
          typeof filterValues.start_occupancy_date_orig !== "undefined"
            ? moment(filterValues.start_occupancy_date_orig).toDate()
            : null,
        end_occupancy_date_orig:
          typeof filterValues.end_occupancy_date_orig !== "undefined"
            ? moment(filterValues.end_occupancy_date_orig).toDate()
            : null,
        months_occupancy_date_orig:
          typeof filterValues.months_occupancy_date_orig !== "undefined"
            ? filterValues.months_occupancy_date_orig
            : "",

        floor_number:
          typeof filterValues.floor_number !== "undefined"
            ? filterValues.floor_number
            : [],

        complexChargeableArea:
          typeof filterValues.complexChargeableArea !== "undefined"
            ? filterValues.complexChargeableArea
            : original_range_min_max_arr.complexChargeableArea,
        buildingChargeableArea:
          typeof filterValues.buildingChargeableArea !== "undefined"
            ? filterValues.buildingChargeableArea
            : original_range_min_max_arr.buildingChargeableArea,
        start_exitDate:
          typeof filterValues.start_exitDate !== "undefined"
            ? moment(filterValues.start_exitDate).toDate()
            : null,
        end_exitDate:
          typeof filterValues.end_exitDate !== "undefined"
            ? moment(filterValues.end_exitDate).toDate()
            : null,
        months_exitDate:
          typeof filterValues.months_exitDate !== "undefined"
            ? filterValues.months_exitDate
            : "",
      });
    } else {
      let original_range_min_max_arr = [];
      Object.keys(this.props.filtersGroup).map((main_category, i) =>
        Object.values(this.props.filtersGroup)[i].map((fields) => {
          if (fields.type === "range") {
            let rangeKey = fields["filter-name"];
            this.setState({ [rangeKey]: [fields.min, fields.max] });
            original_range_min_max_arr[fields["filter-name"]] = [
              fields.min,
              fields.max,
            ];
            this.setState({
              original_range_min_max: original_range_min_max_arr,
            });
          }
        })
      );
    }
  }

  openModal() {
    this.setState({ isOpen: true });
  }
  closeModal = () => this.setState({ isOpen: false });

  closeSearchBox(e) {
    this.props.dispatch({
      type: "HIDE_FILTER_DIV",
      payload: { showFilterDiv: false },
    });
  }
  rangeLimit(value) {
    if (value > 0) {
      return false;
    } else return true;
  }

  handleChild(e) {
    e.stopPropagation();
  }

  render() {
    const { before } = DateRangePicker;

    const eventhandler = (component_name, component_value) => {
      this.setState({ [component_name]: component_value });
    };

    const rangeSelecter = (component_name, component_value) => {
      this.setState({ [component_name]: component_value });
    };

    const startDateHandler = (component_name, start_date) => {
      // this.state[fields['start_'+fields['filter-name']]]
      this.setState({ ["start_" + component_name]: start_date });
      if (
        this.state["end_" + component_name] !== null &&
        new Date(this.state["end_" + component_name]) < new Date(start_date)
      ) {
        this.setState({ ["end_" + component_name]: null });
      }
    };

    const endDateHandler = (component_name, end_date) => {
      this.setState({ ["end_" + component_name]: end_date });
    };

    const monthsAdd = (component_name, e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        var newDate = moment(new Date()).add(e.target.value, "M").toDate();
        this.setState({
          ["start_" + component_name]: new Date(),
          ["end_" + component_name]: newDate,
          ["months_" + component_name]: e.target.value,
        });
      }
    };

    const monthsSubtract = (component_name, e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        var newDate = moment(new Date()).subtract(e.target.value, "M").toDate();
        this.setState({
          ["end_" + component_name]: new Date(),
          ["start_" + component_name]: newDate,
          ["months_" + component_name]: e.target.value,
        });
      }
    };

    const searchBoxValidation = (values) => {
      const errors = {};

      let submitValues = {};
      Object.keys(values).map((field, i) => {
        let value_str = null;
        if (
          field == "securityDeposit" ||
          field == "startingRent" ||
          field == "startingRentCarpet" ||
          field == "currentRent" ||
          field == "currentRentCarpet" ||
          field == "leaseTerm" ||
          field == "rentFreePeriod" ||
          field == "lockinPeriod" ||
          field == "transactionSize" ||
          field == "perSqFt" ||
          field == "totalConsideration" ||
          field == "areaPurchased" ||
          field == "complexChargeableArea" ||
          field == "buildingChargeableArea"
        ) {
          value_str = this.state.original_range_min_max[field].join("|");
        } else {
          value_str = [0, 0].join("|");
        }

        if (
          values[field] === null ||
          values[field].length === 0 ||
          values[field] === "" ||
          (Array.isArray(values[field]) &&
            typeof this.state.original_range_min_max[field] !== undefined &&
            values[field].join("|") === value_str)
        ) {
        } else {
          submitValues[field] = values[field];
        }
      });
      if (Object.keys(submitValues).length === 0) {
        errors.error = "Select at least one filter";
        this.setState({ showAlert: true });
      }
      return errors;
    };

    const handleSaveChange = (e) => {
      this.setState({ filterSaveName: e.target.value });
    };

    const handleSave = () => {
      // let values = this.state;
      // // do what you want like on submit
      // const errors = {};
      // // errors.text3 = 'Invalid email address';

      // let submitValues = {};
      // Object.keys(values).map((field, i) => {
      //   if (values[field] === null || values[field].length === 0 || values[field] === "" || (Array.isArray(values[field]) && values[field].join('|') === [0, 0].join('|'))) {

      //   } else {
      //     submitValues[field] = values[field];
      //   }
      // });

      // if (Object.keys(submitValues).length !== 0) {
      //   errors.error = 'Select at least one filter1';
      //   this.setState({ showAlert: true })
      //   alert(errors.error);
      // }
      // console.log('out');
      // return false;
      this.setState({ saveClicked: true });
    };

    const handleReset = (resetForm) => {
      var uri = this.props.location.pathname;
      this.props.history.push(uri);
      this.setState({
        city: [],
        region: [],
        macromarket: [],
        micromarket: [],
        pincode: [],
        complex: [],
        building: [],
        building_grade: [],
        // propertytype: [],
        building_category: [],
        spacetype: [],
        property_condition: [],
        tenant: [],
        sector: [],
        developer: [],
        landlord: [],
        ownership_type: [],
        owner: [],
        renewed_lease: [],
        document_type: [],
        active: [],
        Lease_Id: [],
        Sale_Id: [],
        seller: [],
        purchaser: [],
        end_status: [],
        brands_parent: [],

        securityDeposit: [0, 0],
        startingRent: [0, 0],
        startingRentCarpet: [0, 0],
        currentRent: [0, 0],
        currentRentCarpet: [0, 0],
        leaseTerm: [0, 0],
        rentFreePeriod: [0, 0],
        lockinPeriod: [0, 0],
        transactionSize: [0, 0],
        perSqFt: [0, 0],
        totalConsideration: [0, 0],
        areaPurchased: [0, 0],

        start_leaseExpiryDate: null,
        end_leaseExpiryDate: null,
        months_leaseExpiryDate: "",

        start_lockinPeriodEndDate: null,
        end_lockinPeriodEndDate: null,
        months_lockinPeriodEndDate: "",

        start_executionDate: null,
        end_executionDate: null,
        months_executionDate: "",

        start_commencementDate: null,
        end_commencementDate: null,
        months_commencementDate: "",

        start_absorptionDate: null,
        end_absorptionDate: null,
        months_absorptionDate: "",

        start_occupancy_date_orig: null,
        end_occupancy_date_orig: null,
        months_occupancy_date_orig: "",

        start_exitDate: null,
        end_exitDate: null,
        months_exitDate: "",

        floor_number: [],

        complexChargeableArea: [0, 0],
        buildingChargeableArea: [0, 0],
      });
      this.props.dispatch({
        type: "CHANGE_SELECTED_FILTER",
        payload: {},
      });
      // this.props.onChange();
      this.props.dispatch({
        type: "HIDE_FILTER_DIV",
        payload: { showFilterDiv: false },
      });
    };

    if (this.state.redirect === true) {
      this.state.redirect = false;
      return <Redirect to={this.state.uri} />;
    }

    if (this.state.showFilter === false) {
      return (
        <div className="row filterContainer">
          <div className="col-lg-12">
            <div>Loading Filters</div>
          </div>
        </div>
      );
    }

    if (this.state.showFilter === true) {
      return (
        <div
          className="searchboxWrapper"
          style={{ height: "100vh" }}
          onClick={(e) => {
            this.closeSearchBox(e);
          }}
        >
          <div
            className="row filterContainer"
            onClick={(e) => {
              this.handleChild(e);
            }}
          >
            <div className="col-lg-12" style={{ position: "relative" }}>
              <Formik
                initialValues={{
                  city: this.state.city,
                  region: this.state.region,
                  macromarket: this.state.macromarket,
                  micromarket: this.state.micromarket,
                  pincode: this.state.pincode,
                  complex: this.state.complex,
                  building: this.state.building,
                  building_grade: this.state.building_grade,
                  // propertytype: this.state.propertytype,
                  building_category: this.state.building_category,
                  spacetype: this.state.spacetype,
                  property_condition: this.state.property_condition,
                  tenant: this.state.tenant,
                  sector: this.state.sector,
                  developer: this.state.developer,
                  landlord: this.state.landlord,
                  ownership_type: this.state.ownership_type,
                  owner: this.state.owner,
                  renewed_lease: this.state.renewed_lease,
                  document_type: this.state.document_type,
                  active: this.state.active,
                  Lease_Id: this.state.Lease_Id,
                  Sale_Id: this.state.Sale_Id,
                  seller: this.state.seller,
                  purchaser: this.state.purchaser,
                  end_status: this.state.end_status,
                  brands_parent: this.state.brands_parent,

                  securityDeposit: this.state.securityDeposit,
                  startingRent: this.state.startingRent,
                  startingRentCarpet: this.state.startingRentCarpet,
                  currentRent: this.state.currentRent,
                  currentRentCarpet: this.state.currentRentCarpet,
                  leaseTerm: this.state.leaseTerm,
                  rentFreePeriod: this.state.rentFreePeriod,
                  lockinPeriod: this.state.lockinPeriod,
                  transactionSize: this.state.transactionSize,
                  perSqFt: this.state.perSqFt,
                  totalConsideration: this.state.totalConsideration,
                  areaPurchased: this.state.areaPurchased,

                  start_leaseExpiryDate: this.state.start_leaseExpiryDate,
                  end_leaseExpiryDate: this.state.end_leaseExpiryDate,
                  months_leaseExpiryDate: this.state.months_leaseExpiryDate,

                  start_lockinPeriodEndDate:
                    this.state.start_lockinPeriodEndDate,
                  end_lockinPeriodEndDate: this.state.end_lockinPeriodEndDate,
                  months_lockinPeriodEndDate:
                    this.state.months_lockinPeriodEndDate,

                  start_executionDate: this.state.start_executionDate,
                  end_executionDate: this.state.end_executionDate,
                  months_executionDate: this.state.months_executionDate,

                  start_commencementDate: this.state.start_commencementDate,
                  end_commencementDate: this.state.end_commencementDate,
                  months_commencementDate: this.state.months_commencementDate,

                  start_absorptionDate: this.state.start_absorptionDate,
                  end_absorptionDate: this.state.end_absorptionDate,
                  months_absorptionDate: this.state.months_absorptionDate,

                  start_exitDate: this.state.start_exitDate,
                  end_exitDate: this.state.end_exitDate,
                  months_exitDate: this.state.months_exitDate,

                  start_occupancy_date_orig:
                    this.state.start_occupancy_date_orig,
                  end_occupancy_date_orig: this.state.end_occupancy_date_orig,
                  months_occupancy_date_orig:
                    this.state.months_occupancy_date_orig,

                  floor_number: this.state.floor_number,

                  complexChargeableArea: this.state.complexChargeableArea,
                  buildingChargeableArea: this.state.buildingChargeableArea,
                }}
                enableReinitialize
                validate={searchBoxValidation}
                onSubmit={(values, { setFieldError }) => {
                  let submitValues = {};
                  let urlValues = {};

                  Object.keys(values).map((field, i) => {
                    if (
                      values[field] === null ||
                      values[field].length === 0 ||
                      values[field] === "" ||
                      (Array.isArray(values[field]) &&
                        values[field].join("|") === [0, 0].join("|"))
                    ) {
                    } else {
                      if (
                        field == "securityDeposit" ||
                        field == "startingRent" ||
                        field == "startingRentCarpet" ||
                        field == "currentRent" ||
                        field == "currentRentCarpet" ||
                        field == "leaseTerm" ||
                        field == "rentFreePeriod" ||
                        field == "lockinPeriod" ||
                        field == "transactionSize" ||
                        field == "perSqFt" ||
                        field == "totalConsideration" ||
                        field == "areaPurchased" ||
                        field == "complexChargeableArea" ||
                        field == "buildingChargeableArea"
                      ) {
                        // console.log(
                        //   field,
                        //   this.state[field],
                        //   this.state.original_range_min_max[field]
                        // );

                        // console.log(this.state[field].join("|"))
                        // console.log(this.state.original_range_min_max[field].join("|"))

                        // if (
                        //   JSON.stringify(this.state[field]) !=
                        //   JSON.stringify(
                        //     this.state.original_range_min_max[field]
                        //   )
                        // )
                        if (
                          this.state[field].join("|") !==
                          this.state.original_range_min_max[field].join("|")
                        ) {
                          submitValues[field + "Start"] = [
                            {
                              value: values[field][0].toString(),
                              id: "",
                              label: values[field][0].toString(),
                            },
                          ];
                          submitValues[field + "End"] = [
                            {
                              value: values[field][1].toString(),
                              id: "",
                              label: values[field][1].toString(),
                            },
                          ];
                        }
                      } else if (
                        field == "start_leaseExpiryDate" ||
                        field == "end_leaseExpiryDate" ||
                        field == "start_lockinPeriodEndDate" ||
                        field == "end_lockinPeriodEndDate" ||
                        field == "start_executionDate" ||
                        field == "end_executionDate" ||
                        field == "start_commencementDate" ||
                        field == "end_commencementDate" ||
                        field == "start_absorptionDate" ||
                        field == "end_absorptionDate" ||
                        field == "start_occupancy_date_orig" ||
                        field == "end_occupancy_date_orig" ||
                        field == "start_exitDate" ||
                        field == "end_exitDate"
                      ) {
                        submitValues[keyMapping[field]] = [
                          {
                            value: moment(values[field]).format("X"),
                            id: "",
                            label: moment(values[field]).format("YYYY-MM-DD"),
                          },
                        ];
                      } else {
                        if (typeof keyMapping[field] !== "undefined")
                          submitValues[keyMapping[field]] = values[field];
                      }

                      if (
                        field == "securityDeposit" ||
                        field == "startingRent" ||
                        field == "startingRentCarpet" ||
                        field == "currentRent" ||
                        field == "currentRentCarpet" ||
                        field == "leaseTerm" ||
                        field == "rentFreePeriod" ||
                        field == "lockinPeriod" ||
                        field == "transactionSize" ||
                        field == "perSqFt" ||
                        field == "totalConsideration" ||
                        field == "areaPurchased" ||
                        field == "complexChargeableArea" ||
                        field == "buildingChargeableArea"
                      ) {
                        if (
                          this.state[field].join("|") !==
                          this.state.original_range_min_max[field].join("|")
                        ) {
                          urlValues[field] = values[field];
                        }
                      } else {
                        urlValues[field] = values[field];
                      }
                    }
                  });

                  if (this.state.saveClicked) {
                    this.setState({ showAlert: true });
                    if (this.state.filterSaveName == "") {
                      setFieldError("error", "Filter name is empty");
                      return false;
                    }

                    var body = new FormData();
                    body.append("filter-name", this.state.filterSaveName);
                    body.append("action", 2);
                    body.append("filter-id", 0);
                    body.append("mode", 1);
                    body.append("present-count", 100);
                    body.append("filter-value", JSON.stringify(submitValues));
                    body.append("screener", "edge_office");
                    apiMiddleware
                      .post("api/screener/save-filter", body)
                      .then((res) => {
                        setFieldError("error", res.data[0]);
                      });
                    return false;
                  }
                  // console.log(submitValues);
                  if (Object.keys(submitValues).length !== 0) {
                    console.log(submitValues);
                    var body = new FormData();
                    body.append("filter-value", JSON.stringify(submitValues));
                    body.append("screener", "edge_office");
                    apiSaveRecentSearches.post(body).then((res) => {
                      setFieldError("error", res.data[0]);

                      // var uri = this.props.history.createHref({pathname: this.props.location.pathname}) + "?filter=" + encodeURIComponent(JSON.stringify(submitValues));
                    });
                    var uri =
                      this.props.location.pathname +
                      "?filter=" +
                      encodeURIComponent(JSON.stringify(urlValues));
                    this.setState({ uri: uri, redirect: true });

                    this.props.dispatch({
                      type: "CHANGE_SELECTED_FILTER",
                      payload: submitValues,
                    });
                    this.props.onChange();
                  }
                }}
              >
                {({ errors, touched }) => (
                  <Form>
                    <Tabs
                      defaultActiveKey="Location"
                      id="uncontrolled-tab-example"
                      className="mb-3"
                    >
                      {Object.keys(this.state.filters).map(
                        (main_category, i) => (
                          <Tab
                            eventKey={main_category}
                            title={main_category}
                            key={main_category}
                          >
                            <div className="container-fluid">
                              <div className="row">
                                {Object.values(this.state.filters)[i].map(
                                  (fields) => (
                                    <div className="col-lg-4 mb-2">
                                      <div className="row">
                                        <div className="col-lg-12">
                                          <label>{fields.title}</label>
                                        </div>
                                        <div className="col-lg-12">
                                          {fields.type ===
                                          "autocompleteSourceDialog" ? (
                                            <>
                                              <RemoteAutoSuggest
                                                component_name={fields.params}
                                                filter_name={
                                                  fields["filter-name"]
                                                }
                                                onChange={eventhandler}
                                                defaultVal={
                                                  this.state[fields.params]
                                                }
                                              />
                                            </>
                                          ) : null}

                                          {fields.type === "range" ? (
                                            <>
                                              {/* <span>
                                                {parseInt(
                                                  this.state[
                                                    fields["filter-name"]
                                                  ].slice(1)
                                                ) === 0
                                                  ? fields.min.toLocaleString()
                                                  : parseInt(
                                                      this.state[
                                                        fields["filter-name"]
                                                      ].slice(0, 1)
                                                    ).toLocaleString("en")}
                                              </span>
                                              <span style={{ float: "right" }}>
                                                {parseInt(
                                                  this.state[
                                                    fields["filter-name"]
                                                  ].slice(1)
                                                ) === 0
                                                  ? fields.max.toLocaleString()
                                                  : parseInt(
                                                      this.state[
                                                        fields["filter-name"]
                                                      ].slice(1)
                                                    ).toLocaleString("en")}
                                              </span> */}
                                              <InputGroup
                                                style={{
                                                  border:
                                                    this.state[
                                                      fields["filter-name"]
                                                    ].showError == true
                                                      ? "1px solid red"
                                                      : "",
                                                }}
                                              >
                                                <InputNumber
                                                  min={fields.min}
                                                  max={fields.max}
                                                  value={
                                                    this.state[
                                                      fields["filter-name"]
                                                    ][0]
                                                    // fields.min
                                                  }
                                                  defaultValue={
                                                    this.state[
                                                      fields["filter-name"]
                                                    ][0]
                                                    // fields.min
                                                  }
                                                  onChange={(nextValue) => {
                                                    if (nextValue == "") {
                                                      nextValue = 0;
                                                    }

                                                    nextValue =
                                                      parseInt(nextValue);
                                                    const state_start =
                                                      this.state[
                                                        fields["filter-name"]
                                                      ][0];
                                                    const state_end =
                                                      this.state[
                                                        fields["filter-name"]
                                                      ][1];
                                                    const start = fields.min;
                                                    const end = fields.max;

                                                    // if (nextValue > end || nextValue > state_end || nextValue < start) {
                                                    //   // alert('Out of range value. Max allowed '+end);
                                                    //   return;
                                                    // }

                                                    if (
                                                      nextValue < start ||
                                                      nextValue > end
                                                    ) {
                                                      this.setState({
                                                        errorMsg:
                                                          "Value out of range of [" +
                                                          start +
                                                          "," +
                                                          end +
                                                          "]",
                                                      });
                                                      this.state[
                                                        fields["filter-name"]
                                                      ].showError = true;
                                                      // alert();
                                                      return;
                                                    }

                                                    if (nextValue > state_end) {
                                                      // alert(
                                                      //   "Value more than end value"
                                                      // );
                                                      this.setState({
                                                        errorMsg:
                                                          "Value more than end value",
                                                      });
                                                      this.state[
                                                        fields["filter-name"]
                                                      ].showError = true;
                                                      return;
                                                    }

                                                    rangeSelecter(
                                                      fields["filter-name"],
                                                      [nextValue, state_end]
                                                    );
                                                  }}
                                                />
                                                <InputGroup.Addon>
                                                  to
                                                </InputGroup.Addon>
                                                <InputNumber
                                                  min={fields.min}
                                                  max={fields.max}
                                                  value={
                                                    this.state[
                                                      fields["filter-name"]
                                                    ][1]
                                                    // fields.max
                                                  }
                                                  defaultValue={
                                                    this.state[
                                                      fields["filter-name"]
                                                    ][1]
                                                    // fields.max
                                                  }
                                                  onChange={(nextValue) => {
                                                    if (nextValue == "") {
                                                      nextValue = 0;
                                                    }

                                                    nextValue =
                                                      parseInt(nextValue);
                                                    const state_start =
                                                      this.state[
                                                        fields["filter-name"]
                                                      ][0];
                                                    const state_end =
                                                      this.state[
                                                        fields["filter-name"]
                                                      ][1];
                                                    const start = fields.min;
                                                    const end = fields.max;

                                                    // if (nextValue < start || nextValue < state_start || nextValue > end) {
                                                    //   // alert('Out of range value. Max allowed '+end);
                                                    //   return;
                                                    // }

                                                    if (
                                                      nextValue < start ||
                                                      nextValue > end
                                                    ) {
                                                      this.setState({
                                                        errorMsg:
                                                          "Value out of range of [" +
                                                          start +
                                                          "," +
                                                          end +
                                                          "]",
                                                      });
                                                      this.state[
                                                        fields["filter-name"]
                                                      ].showError = true;
                                                      return;
                                                    }
                                                    if (
                                                      nextValue < state_start
                                                    ) {
                                                      this.setState({
                                                        errorMsg:
                                                          "Value less than start value",
                                                      });
                                                      this.state[
                                                        fields["filter-name"]
                                                      ].showError = true;
                                                      return;
                                                    }

                                                    rangeSelecter(
                                                      fields["filter-name"],
                                                      [state_start, nextValue]
                                                    );
                                                  }}
                                                />
                                              </InputGroup>

                                              <RangeSlider
                                                className="mb-3"
                                                component_name={
                                                  fields["filter-name"]
                                                }
                                                min={fields.min}
                                                max={fields.max}
                                                onChange={(nextValue) => {
                                                  rangeSelecter(
                                                    fields["filter-name"],
                                                    nextValue
                                                  );
                                                }}
                                                defaultValue={
                                                  this.state[
                                                    fields["filter-name"]
                                                  ]
                                                  // [fields.min, fields.max]
                                                  // typeof fields.min !==
                                                  //   undefined &&
                                                  // typeof fields.max !==
                                                  //   undefined
                                                  //   ? [fields.min, fields.max]
                                                  //   : this.state[
                                                  //       fields["filter-name"]
                                                  //     ]
                                                }
                                                value={
                                                  this.state[
                                                    fields["filter-name"]
                                                  ]
                                                  // [fields.min, fields.max]
                                                  // this.state[
                                                  //   fields["filter-name"]
                                                  // ]
                                                  //   ? this.state[
                                                  //       fields["filter-name"]
                                                  //     ]
                                                  //   : [fields.min, fields.max]
                                                }
                                                progress
                                              />
                                              {this.state[fields["filter-name"]]
                                                .showError && (
                                                <p
                                                  style={{
                                                    fontSize: "12px",
                                                    color: "red",
                                                  }}
                                                >
                                                  {this.state.errorMsg}
                                                </p>
                                              )}
                                            </>
                                          ) : null}

                                          {fields.type === "date" ? (
                                            fields["filter-name"] ===
                                              "leaseExpiryDate" ||
                                            fields["filter-name"] ===
                                              "lockinPeriodEndDate" ? (
                                              <>
                                                <div className="row inputWidth100">
                                                  <div className="col-lg-6 m-0">
                                                    {/* <label>From:</label> */}
                                                    <DatePicker
                                                      format="yyyy-MM-dd"
                                                      placeholder="From"
                                                      ranges={[]}
                                                      oneTap={true}
                                                      onChange={(start_date) =>
                                                        startDateHandler(
                                                          fields["filter-name"],
                                                          start_date
                                                        )
                                                      }
                                                      value={
                                                        this.state[
                                                          "start_" +
                                                            fields[
                                                              "filter-name"
                                                            ]
                                                        ]
                                                      }
                                                    />
                                                  </div>
                                                  <div className="col-lg-6 m-0">
                                                    {/* <label>To:</label> */}
                                                    <DatePicker
                                                      format="yyyy-MM-dd"
                                                      placeholder="To"
                                                      ranges={[]}
                                                      oneTap={true}
                                                      onChange={(end_date) =>
                                                        endDateHandler(
                                                          fields["filter-name"],
                                                          end_date
                                                        )
                                                      }
                                                      disabledDate={before(
                                                        new Date(
                                                          this.state[
                                                            "start_" +
                                                              fields[
                                                                "filter-name"
                                                              ]
                                                          ]
                                                        )
                                                      )}
                                                      value={
                                                        this.state[
                                                          "end_" +
                                                            fields[
                                                              "filter-name"
                                                            ]
                                                        ]
                                                      }
                                                    />
                                                  </div>
                                                  <div className="col-lg-12 text-center my-2">
                                                    <label className="m-0">
                                                      OR
                                                    </label>
                                                  </div>
                                                  <div className="col-lg-12">
                                                    <Field
                                                      autoComplete="off"
                                                      type="text"
                                                      name={
                                                        "months_" +
                                                        fields["filter-name"]
                                                      }
                                                      placeholder={
                                                        fields[
                                                          "date-helper-text-pre"
                                                        ]
                                                      }
                                                      onKeyDown={(e) =>
                                                        monthsAdd(
                                                          fields["filter-name"],
                                                          e
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </>
                                            ) : fields["filter-name"] ===
                                              "executionDate" ? (
                                              <>
                                                <div className="row inputWidth100">
                                                  <div className="col-lg-6 m-0">
                                                    {/* <label>From:</label> */}
                                                    <DatePicker
                                                      format="yyyy-MM-dd"
                                                      placeholder="From"
                                                      ranges={[]}
                                                      oneTap={true}
                                                      onChange={(start_date) =>
                                                        startDateHandler(
                                                          fields["filter-name"],
                                                          start_date
                                                        )
                                                      }
                                                      value={
                                                        this.state[
                                                          "start_" +
                                                            fields[
                                                              "filter-name"
                                                            ]
                                                        ]
                                                      }
                                                    />
                                                  </div>
                                                  <div className="col-lg-6 m-0">
                                                    {/* <label>:</label> */}
                                                    <DatePicker
                                                      format="yyyy-MM-dd"
                                                      placeholder="To"
                                                      ranges={[]}
                                                      oneTap={true}
                                                      onChange={(end_date) =>
                                                        endDateHandler(
                                                          fields["filter-name"],
                                                          end_date
                                                        )
                                                      }
                                                      disabledDate={before(
                                                        new Date(
                                                          this.state[
                                                            "start_" +
                                                              fields[
                                                                "filter-name"
                                                              ]
                                                          ]
                                                        )
                                                      )}
                                                      value={
                                                        this.state[
                                                          "end_" +
                                                            fields[
                                                              "filter-name"
                                                            ]
                                                        ]
                                                      }
                                                    />
                                                  </div>
                                                  <div className="col-lg-12 text-center my-2">
                                                    <label className="m-0">
                                                      OR
                                                    </label>
                                                  </div>
                                                  <div className="col-lg-12">
                                                    <Field
                                                      autoComplete="off"
                                                      type="text"
                                                      name={
                                                        "months_" +
                                                        fields["filter-name"]
                                                      }
                                                      placeholder={
                                                        fields[
                                                          "date-helper-text-pre"
                                                        ]
                                                      }
                                                      onKeyDown={(e) =>
                                                        monthsSubtract(
                                                          fields["filter-name"],
                                                          e
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </>
                                            ) : fields["filter-name"] ===
                                                "commencementDate" ||
                                              fields["filter-name"] ===
                                                "absorptionDate" ||
                                              fields["filter-name"] ===
                                                "occupancy_date_orig" ||
                                              fields["filter-name"] ===
                                                "exitDate" ? (
                                              <>
                                                <div className="row">
                                                  <div className="col-lg-6 m-0">
                                                    {/* <label>:</label> */}
                                                    <DatePicker
                                                      format="yyyy-MM-dd"
                                                      placeholder="From"
                                                      ranges={[]}
                                                      oneTap={true}
                                                      onChange={(start_date) =>
                                                        startDateHandler(
                                                          fields["filter-name"],
                                                          start_date
                                                        )
                                                      }
                                                      value={
                                                        this.state[
                                                          "start_" +
                                                            fields[
                                                              "filter-name"
                                                            ]
                                                        ]
                                                      }
                                                    />
                                                  </div>
                                                  <div className="col-lg-6 m-0">
                                                    {/* <label>:</label> */}
                                                    <DatePicker
                                                      format="yyyy-MM-dd"
                                                      placeholder="To"
                                                      ranges={[]}
                                                      oneTap={true}
                                                      onChange={(end_date) =>
                                                        endDateHandler(
                                                          fields["filter-name"],
                                                          end_date
                                                        )
                                                      }
                                                      disabledDate={before(
                                                        new Date(
                                                          this.state[
                                                            "start_" +
                                                              fields[
                                                                "filter-name"
                                                              ]
                                                          ]
                                                        )
                                                      )}
                                                      value={
                                                        this.state[
                                                          "end_" +
                                                            fields[
                                                              "filter-name"
                                                            ]
                                                        ]
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </>
                                            ) : null
                                          ) : null}

                                          {fields.type ===
                                          "autocompleteSourceLocal" ? (
                                            <LocalAutoSuggest
                                              component_name={
                                                fields["filter-name"]
                                              }
                                              filter_name={
                                                fields["filter-name"]
                                              }
                                              onChange={eventhandler}
                                              defaultVal={
                                                this.state[
                                                  fields["filter-name"]
                                                ]
                                              }
                                              options={fields.filters}
                                            />
                                          ) : null}
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </Tab>
                        )
                      )}
                    </Tabs>

                    <div className="filterErrMsg">
                      {errors.error && this.state.showAlert === true && (
                        <Alert
                          variant="danger"
                          onClose={() => this.setState({ showAlert: false })}
                          dismissible
                          show={this.state.showAlert}
                        >
                          <Alert.Heading>{errors.error}</Alert.Heading>
                        </Alert>
                      )}
                      <div className="col-lg-12  text-end">
                        <button
                          className="tabFormButton applyBtn"
                          type="submit"
                          onClick={() => {
                            this.setState({ saveClicked: false });
                          }}
                        >
                          Apply
                        </button>
                        <button
                          className="tabFormButton"
                          type="button"
                          onClick={handleReset}
                        >
                          Clear
                        </button>
                      </div>
                      {/* <div className="col-lg-4">
                                            <input name="filter_name" value={this.state.filterSaveName} onChange={(e) => handleSaveChange(e)} />
                                            <button className="tabFormButton" type="submit" onClick={() => handleSave()}>
                                                Save
                                            </button>
                                            <button className="tabFormButton" type="button">
                                                Load
                                            </button>
                                        </div> */}
                      {/* <div className="col-lg-8 text-end">
                        <button
                          className="tabFormButton"
                          type="button"
                          onClick={(e) => {
                            this.openModal();
                          }}
                        >
                          Save
                        </button>
                        <DropdownButton
                          id="dropdown-basic-button"
                          title="Load or Delete Saved Filter"
                        >
                          <Dropdown.Item>
                            Action
                            <FontAwesomeIcon icon={faTimes} />
                          </Dropdown.Item>
                          <Dropdown.Item>
                            Another action <FontAwesomeIcon icon={faTimes} />
                          </Dropdown.Item>
                          <Dropdown.Item>
                            Something else <FontAwesomeIcon icon={faTimes} />
                          </Dropdown.Item>
                        </DropdownButton>
                      </div> */}
                    </div>
                  </Form>
                )}
              </Formik>
              <FontAwesomeIcon
                icon={faTimes}
                className="filterCloseBtn"
                onClick={(e) => {
                  this.props.dispatch({
                    type: "HIDE_FILTER_DIV",
                    payload: { showFilterDiv: false },
                  });
                }}
              />
            </div>
            <div className="row saveFilterPopup">
              <div className="col-lg-12">
                <Modal
                  show={this.state.isOpen}
                  onHide={this.closeModal}
                  size="md"
                  className="documentModal"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <div className="container">
                        <div className="row">
                          <div className="col-lg-12">
                            <h2>Save Filter</h2>
                          </div>
                        </div>
                      </div>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="container">
                      <div className="row">
                        <Formik initialValues={{ filterName: "" }}>
                          <Form>
                            <div className="col-lg-12 text-center">
                              <Field
                                type="text"
                                name="filterName"
                                className="filterNameInput"
                              ></Field>
                            </div>
                            <div className="col-lg-12 text-center mt-4">
                              <button className="saveFilterBtn" type="button">
                                Save
                              </button>
                              <BootstrapSwitchButton
                                checked={true}
                                onlabel="Notification On"
                                offlabel="Notification Off"
                              />
                            </div>
                          </Form>
                        </Formik>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
export default withRouter(connect(mapStateToProps)(SearchBox));
